import React from "react";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-content">
        <div className="profile-details">
          <h1 className="profile-name">
            Souleimane <span className="highlighted-text">Zeggai</span>
          </h1>

          <h2 className="profile-title">Développeur Full-Stack</h2>

          <p className="profile-subtitle">
            Je conçois des applications web modernes, performantes et
            maintenables.
          </p>

          <div className="profile-stack">
            <span>React</span>
            <span className="stack-dot">·</span>
            <span>Node.js</span>
            <span className="stack-dot">·</span>
            <span>TypeScript</span>
            <span className="stack-dot">·</span>
            <span>MongoDB</span>
            <span className="stack-dot">·</span>
            <span>PHP</span>
          </div>

          <div className="profile-actions">
            <button
              className="profile-btn profile-btn-primary"
              onClick={() => {
                const el = document.getElementById("Projets");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Voir mes projets
            </button>
            <a
              href="https://github.com/souleimane-z"
              target="_blank"
              rel="noopener noreferrer"
              className="profile-btn profile-btn-secondary"
            >
              <i className="fa fa-github"></i>
              GitHub
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
